export function saveCommonQueryParams(searchParams) {
    const token = searchParams.get('token');
    if (token) {
        localStorage.setItem('promo', token);
    }

    const i = parseInt(searchParams.get('i'), 10);
    if (!isNaN(i)) {
        localStorage.setItem('i', i.toString());
    }
    const period = Number.isInteger(i) && i >= 1 && i <= 30 ? i : 1;
    localStorage.setItem('period', period.toString());

    const validTariffs = [1, 3, 6, 12];
    const j = parseInt(searchParams.get('j') || '', 10);
    if (!isNaN(j)) {
        localStorage.setItem('j', j.toString());
    }
    const tariff = validTariffs.includes(j) ? j : 1;
    localStorage.setItem('tariff', tariff.toString());
}